import { ROUTES } from '@/constants';
import { generatePath } from 'react-router-dom';

export const sidebarItems = [
	{ label: 'Encuentra tu notario', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
	{ label: 'Academia de Opositores', to: ROUTES.INFORMACION_ACADEMIA_OPOSITORES },
	{ label: 'Corporación Notarial', to: ROUTES.INFORMACION_ORGANISMOS_INTERNACIONALES },
	{ label: 'Encuentra tu escritura', to: ROUTES.INFORMACION_ENCUENTRA_ESCRITURA },
	{
		label: 'Nuevas actuaciones Notariales',
		to: ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES,
		children: [
			{
				label: 'Sucesiones',
				to: generatePath(ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE, { page: 'sucesiones' }),
				matchDescendants: true,
			},
			{
				label: 'Matrimonio y régimen matrimonial',
				to: generatePath(ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE, {
					page: 'matrimonio-y-regimen-matrimonial',
				}),
				matchDescendants: true,
			},
			{
				label: 'Inmuebles',
				to: generatePath(ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE, { page: 'inmuebles' }),
				matchDescendants: true,
			},
			{
				label: 'Reclamación y pago de deudas',
				to: generatePath(ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE, {
					page: 'reclamacion-y-pago-de-deudas',
				}),
				matchDescendants: true,
			},
			{
				label: 'Otros',
				to: generatePath(ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE, { page: 'otros' }),
				matchDescendants: true,
			},
		],
	},
	{ label: 'Enlaces de interés', to: ROUTES.INFORMACION_ENLACES_INTERES },
];
